import PropTypes from "prop-types";
import React from "react";
import { logout } from "actions/loginActions";
import { withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";

class LogoutPage extends React.Component {
  componentDidMount() {
    const { logout } = this.props;

    logout();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    const { config: { action } = {}, error } = nextProps;

    // Normal logout without redirect
    if (action && action.type && action.type === "redirectToLogin") {
      nextProps.history.push("/");
      return;
    }

    // With custom logout redirect
    if (action && action.type && action.type === "redirectToCustomUrl" && action[action.type]) {
      // eslint-disable-next-line xss/no-location-href-assign
      window.location.href = action[action.type];
      return;
    }

    // handle unauthorized access
    if (error && error.status === 401) {
      nextProps.history.push("/");
    }
  }

  render() {
    return null;
  }
}

LogoutPage.propTypes = {
  logout: PropTypes.func,
  history: PropTypes.object,
  config: PropTypes.object,
};

const mapStateToProps = ({ login }) => ({
  error: login.error,
  config: login.config,
});

const mapDispatchToProps = {
  logout,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoutPage));



// WEBPACK FOOTER //
// ./components/login/LogoutPage.js